// Cambiar el título del widget

// Escuchar cuando el elemento .jdgm-rev-widg__title exista
const judgeMe = (function() {
  return {
    listenWidgetInitialization() {
      if (document.querySelector('.jdgm-rev-widg__title') != null) {
        window.setTimeout(() => {
          this.changeTitle();
        }, 1000);
      } else {
        window.setTimeout(() => {
          this.listenWidgetInitialization();
        }, 100);
      }
    },

    changeTitle() {
      window.console.log('judge-me initialized');
      const $title = $('.jdgm-rev-widg__title').clone().text('OPINIONES DE CLIENTES').addClass('visible');
      $('.jdgm-rev-widg__title').replaceWith($title);
    }
  }
})();

// vanilla js on document ready
document.addEventListener("DOMContentLoaded", function() {
  judgeMe.listenWidgetInitialization();
});
